(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a1-packout-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('a1-packout-finder')) {
  customElements.define('a1-packout-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-status]');
      this.results = this.querySelector('.a1-finder__results');
      this.form.hidden = false;
      this.catalog = null;
      const embeddedCatalog = this.querySelector('[data-catalog]');
      if (embeddedCatalog) {
        try { this.catalog = JSON.parse(embeddedCatalog.textContent); } catch (error) { this.catalog = null; }
      }
      this.form.addEventListener('submit', event => event.preventDefault());
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('reset', () => {
        this.sequence = (this.sequence || 0) + 1;
        this.results.hidden = true;
        this.status.textContent = '';
        document.body.classList.remove('a1-finder-active');
        const cleanUrl = new URL(location.href);
        ['a1_case', 'a1_model'].forEach(key => cleanUrl.searchParams.delete(key));
        history.replaceState(null, '', cleanUrl);
      });
      const incoming = new URLSearchParams(location.search);
      for (const name of ['case', 'model']) {
        const value = incoming.get('a1_' + name);
        if (value) this.form.elements.namedItem(name).value = value.slice(0, 100);
      }
      if (incoming.get('a1_case') || incoming.get('a1_model')) this.update();
    }
    disconnectedCallback() { document.body.classList.remove('a1-finder-active'); }
    async loadCatalog() {
      if (this.catalog) return this.catalog;
      if (!this.loading) {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        this.loading = fetch(url).then(response => { if (!response.ok) throw new Error('Catalog'); return response.text(); }).then(html => {
          const data = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-catalog]');
          if (!data) throw new Error('Catalog');
          this.catalog = JSON.parse(data.textContent);
          return this.catalog;
        }).catch(error => { this.loading = null; throw error; });
      }
      return this.loading;
    }
    async update() {
      const sequence = this.sequence = (this.sequence || 0) + 1;
      const values = Object.fromEntries(new FormData(this.form));
      if (!Object.values(values).some(value => value.trim())) { this.results.hidden = true; this.status.textContent = ''; document.body.classList.remove('a1-finder-active'); return; }
      this.status.textContent = this.status.dataset.loading;
      try {
        const catalog = await this.loadCatalog();
        if (sequence !== this.sequence) return;
        const normal = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
        const matches = catalog.filter(item => {
          const title = item.title.toLowerCase();
          const cases = normal(item.title + ' ' + item.collections.join(' '));
          return (!values.case || cases.includes(values.case)) && (!values.platform || title.includes(values.platform)) && (!values.tool || new RegExp(values.tool, 'i').test(title)) && (!values.model.trim() || normal(item.title + ' ' + item.search).includes(normal(values.model)));
        });
        this.results.replaceChildren();
        for (const item of matches) {
          const link = document.createElement('a'); link.href = item.url;
          if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; img.width = 480; img.height = 480; link.append(img); }
          const title = document.createElement('h3'); title.textContent = item.title;
          const price = document.createElement('p'); price.textContent = item.price;
          link.append(title, price); this.results.append(link);
        }
        this.status.textContent = matches.length ? this.status.dataset.count.replace('[count]', matches.length) : this.status.dataset.empty;
        this.results.hidden = false;
        document.body.classList.add('a1-finder-active');
      } catch (error) { if (sequence !== this.sequence) return; this.status.textContent = this.status.dataset.error; this.results.hidden = true; document.body.classList.remove('a1-finder-active'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
